import { Box, IconButton } from "@mui/material";
import { createColumn } from "../../../utils/function";
import { Edit } from "@mui/icons-material";

export const ColumnBuilder = (setShowModal, setEditData) => {
  const buildColumns = () => {
    const generatedColumns = [];

    generatedColumns.push(
      ...createColumn([
        {
          headerName: "Fiscal year",
          field: "fiscalYear",
        },
        {
          headerName: "Fiscal version",
          field: "version",
        },
        {
          headerName: "Type of copy",
          field: "fiscalYearTypeCopy",
        },
        {
          headerName: "Fiscal year copied",
          field: "fiscalYearDateCopy",
        },
        {
          headerName: "Increase",
          field: "increase",
        },
        {
          headerName: "Fiscal version copied",
          field: "fiscalYearVersionCopy",
        },
        {
          headerName: "Created at",
          field: "createdAt",
        },
        {
          headerName: "Description",
          field: "description",
        },
        {
          field: "actions",
          headerName: "Actions",
          cellRenderer: (params) => {
            return (
              <Box>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  onClick={() => {
                    setEditData(params?.data);
                    setShowModal(true);
                  }}
                >
                  <Edit />
                </IconButton>
              </Box>
            );
          },
        },
      ]),
    );

    return generatedColumns;
  };

  return buildColumns();
};
